import { useCallback } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { routePath } from "../../constants/Routes";

export function useAppNavigation() {
    const history = useHistory();
    const goToWebPlaceOrder = useCallback(
        (state = {}) => {
            history.push({
                pathname: routePath.WEB_PLACE_ORDER,
                state
            });
        },
        [history]
    );

    return {
       goToWebPlaceOrder
    }
}